export const PROVIDER_LABEL = { openai: "OpenAI", anthropic: "Anthropic", gemini: "Google Gemini", fal: "fal.ai" };
export const provName = (p) => PROVIDER_LABEL[p] || p;
export const CAP_LABEL = { text: "Teks / chat", image: "Gambar", stt: "Speech-to-text", tts: "Text-to-speech", video: "Video" };
export const usd = (v, d = 4) => (v == null ? "—" : `$${Number(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: d })}`);
export const fmtTime = (d) => (d ? new Date(d).toLocaleString("id-ID", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
export const QUALITY = {
  gemini: [["Hemat", 1], ["Standar", 1.5], ["Tinggi", 2.25]],
  openai: [["Hemat", 0.27], ["Standar", 1], ["Tinggi", 4]],
};
export const ALERT_KIND = { budget_threshold: "Ambang anggaran", quota_error: "Kuota / limit provider", fallback_used: "Cadangan Emergent dipakai" };
